import { render, staticRenderFns } from "./CenterDialog.vue?vue&type=template&id=4d84b852"
import script from "./CenterDialog.vue?vue&type=script&lang=js"
export * from "./CenterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports